import { MapControls } from '@/components/MapControls'

import { Map } from './components/Map'
import { DriversRoot } from './form/DriversRoot'

import { Box, Stack } from '@mui/material'

export function Drivers() {
  return (
    <Stack direction="row" height="100%" width="100%" data-testid="setup-drivers-root">
      <DriversRoot />

      <Box width="100%" height="100%" flex="0 1 auto">
        <Stack direction="column" height="100%" width="100%">
          <MapControls disableLasso />

          <Map />
        </Stack>
      </Box>
    </Stack>
  )
}
